import { commonApi, companyUUID, getShopifyUserId } from './api';
import { terminal } from '../constant/index';
import { STORAGE_KEY } from '../constant/constant';
import { getLocal } from '../utils/storage';

export interface FormSuccessPayloadInput {
  cid?: string | null;
  formUid?: string | null;
  companyUUID?: string;
  shopifyUserId?: string;
  email?: string;
  formId: string;
  phoneCode?: string;
  phone?: string | null;
  step: number;
  pathname?: string;
  terminal?: 'pc' | 'mobile';
}

export function buildFormSuccessPayload(input: FormSuccessPayloadInput) {
  return {
    cid: input.cid ?? null,
    formUid: input.formUid ?? null,
    event: 'success',
    companyUUID: input.companyUUID || companyUUID,
    shopifyUserId: input.shopifyUserId || getShopifyUserId(),
    email: input.email || '',
    formId: input.formId,
    phoneCode: input.phoneCode || '',
    phone: input.phone || '',
    step: input.step,
    pathname: input.pathname || window.location.pathname,
    terminal: input.terminal || (terminal ? 'pc' : 'mobile')
  };
}

export function reportFormSuccess(input: Omit<FormSuccessPayloadInput, 'cid' | 'formUid' | 'companyUUID' | 'shopifyUserId' | 'pathname' | 'terminal'> & Partial<FormSuccessPayloadInput>) {
  return commonApi(
    buildFormSuccessPayload({
      cid: getLocal(STORAGE_KEY.CID) || null,
      formUid: getLocal(STORAGE_KEY.FORM_UID) || null,
      companyUUID,
      shopifyUserId: getShopifyUserId(),
      pathname: window.location.pathname,
      terminal: terminal ? 'pc' : 'mobile',
      ...input
    }),
    'form/out/success'
  );
}
